// auto-image-optimizer.js
(function () {
  const SHOPIFY_CDN = 'cdn.shopify.com';

  function isShopifyImage(url) {
    return url && url.includes(SHOPIFY_CDN);
  }

  function buildOptimizedUrl(url, width) {
    // Strip existing width param, re-add clean one, force webp
    const clean = url.replace(/([&?])width=\d+/g, '');
    const sep = clean.includes('?') ? '&' : '?';
    return `${clean}${sep}width=${width}&format=webp`;
  }

  function optimizeImage(img) {
    if (img.dataset.optimized) return;
    const src = img.currentSrc || img.src;
    if (!isShopifyImage(src)) return; // skip 3rd-party (e.g. Instagram)

    const rect = img.getBoundingClientRect();
    const displayWidth = Math.ceil(rect.width || img.width || 400);
    const dpr = window.devicePixelRatio || 1;
    const targetWidth = Math.min(Math.ceil(displayWidth * dpr), 2000); // cap at 2000px

    if (targetWidth <= 0) return;

    const optimizedSrc = buildOptimizedUrl(src, targetWidth);
    img.src = optimizedSrc;

    // Also clean up srcset if present, so browser doesn't override with a huge candidate
    if (img.srcset) {
      img.srcset = img.srcset
        .split(',')
        .map(entry => {
          const [u, descriptor] = entry.trim().split(' ');
          return isShopifyImage(u) ? `${buildOptimizedUrl(u, targetWidth)} ${descriptor || ''}`.trim() : entry.trim();
        })
        .join(', ');
    }

    // Prevent layout shift if width/height missing
    if (!img.getAttribute('width') && img.naturalWidth) {
      img.setAttribute('width', img.naturalWidth);
      img.setAttribute('height', img.naturalHeight);
    }

    img.dataset.optimized = 'true';
  }

  function scanImages() {
    document.querySelectorAll('img:not([data-optimized])').forEach(optimizeImage);
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', scanImages);

  // Re-run when new content is injected (predictive search, infinite scroll, etc.)
  const observer = new MutationObserver(() => scanImages());
  observer.observe(document.body, { childList: true, subtree: true });

  // ---- Predictive search ARIA fix ----
  function fixPredictiveSearchAria() {
    document.querySelectorAll('.predictive-search__list-item[role="option"]').forEach(li => {
      const parentUl = li.closest('ul');
      if (parentUl && parentUl.getAttribute('role') !== 'listbox') {
        parentUl.setAttribute('role', 'listbox');
        parentUl.setAttribute('aria-label', 'Search results');
      }
    });
  }

  const ariaObserver = new MutationObserver(fixPredictiveSearchAria);
  ariaObserver.observe(document.body, { childList: true, subtree: true });
})();